const baseConfig = {
  APP_VERSION: "1818",
  INTEGRACAO_URL: "https://integracao.prover.app/",
};

const prover = {
  develop: {
    ...baseConfig,
    API_URL: "http://prover.develop/api-nova/asteria",
    API_ANTIGA_URL: "http://prover.develop/api/v3",
    DOWNLOAD_URL: "http://prover.develop/public/download",
    IMG_URL: "http://prover.develop/public/img",
    BACKEND_IMG_URL: "http://prover.develop/backend/anexo/img?f=",
    PORTAL_URL: "http://prover.develop",
    LOGO_URL: "http://prover.develop/services/loadImg",
    URL_CONTRIBUA: "http://prover.develop/frontend/contribuicao/listar?t=",
    URL_EXAME_SACERDOTAL: "https://formularios.messianica.org.br/",
    SIS_URL: 'http://prover.develop/',
    isMessianica: false,
  },
  producao: {
    ...baseConfig,
    API_URL: "https://portal.sistemaprover.com.br/api/asteria",
    API_ANTIGA_URL: "https://sis.sistemaprover.com.br/api/v3",
    DOWNLOAD_URL: "https://sis.sistemaprover.com.br/public/download",
    IMG_URL: "https://sis.sistemaprover.com.br/public/img",
    BACKEND_IMG_URL: "https://sis.sistemaprover.com.br/backend/anexo/img?f=",
    PORTAL_URL: "https://portal.sistemaprover.com.br",
    LOGO_URL: "https://sis.sistemaprover.com.br/services/loadImg",
    URL_EXAME_SACERDOTAL: "https://formularios.messianica.org.br/",
    URL_CONTRIBUA: "https://portal.sistemaprover.com.br/frontend/contribuicao/listar?t=",
    SIS_URL: 'https://sis.sistemaprover.com.br/',
    isMessianica: false,
  },
  homolog: {
    ...baseConfig,
    API_URL: "https://h-portal.sistemaprover.com.br/api/asteria",
    API_ANTIGA_URL: "https://h-sis.sistemaprover.com.br/api/v3",
    DOWNLOAD_URL: "https://h-sis.sistemaprover.com.br/public/download",
    IMG_URL: "https://h-sis.sistemaprover.com.br/public/img",
    BACKEND_IMG_URL: "https://h-sis.sistemaprover.com.br/backend/anexo/img?f=",
    PORTAL_URL: "https://h-portal.sistemaprover.com.br",
    LOGO_URL: "https://h-sis.sistemaprover.com.br/services/loadImg",
    API_SIS_FRONTEND: "https://h-sis.sistemaprover.com.br/",
    URL_CONTRIBUA: "https://h-portal.sistemaprover.com.br/frontend/contribuicao/listar?t=",
    SIS_URL: 'https://h-sis.sistemaprover.com.br/',
    URL_EXAME_SACERDOTAL: "https://formularios.messianica.org.br/",
    isMessianica: false,
  },
  qa: {
    ...baseConfig,
    API_URL: "https://qa.portal.provertecnologia.com.br/api/asteria",
    API_ANTIGA_URL: "https://qa.sis.provertecnologia.com.br/api/v3",
    DOWNLOAD_URL: "https://qa.sis.provertecnologia.com.br/public/download",
    IMG_URL: "https://qa.sis.provertecnologia.com.br/public/img",
    BACKEND_IMG_URL: "https://qa.sis.provertecnologia.com.br/backend/anexo/img?f=",
    PORTAL_URL: "https://qa.portal.provertecnologia.com.br",
    LOGO_URL: "https://qa.sis.sistemaprover.com.br/services/loadImg",
    URL_EXAME_SACERDOTAL: "https://formularios.staging.messianica.plataformaprover.com.br/",
    URL_CONTRIBUA: "https://qa.portal.sistemaprover.com.br/frontend/contribuicao/listar?t=",
    SIS_URL: 'https://qa.sis.sistemaprover.com.br/',
    INTEGRACAO_URL: "https://inscricoes.qa.prover.zhav.dev",
    isMessianica: false,
  },
};

const messianica = {
  develop: {
    ...baseConfig,
    API_URL: "http://prover.develop/api-nova/asteria",
    API_ANTIGA_URL: "http://prover.develop/api/v3",
    DOWNLOAD_URL: "https://messianica.plataformaprover.com.br/public/download",
    IMG_URL: "https://messianica.plataformaprover.com.br/public/img",
    BACKEND_IMG_URL: "https://messianica.plataformaprover.com.br/backend/anexo/img?f=",
    URL_EXAME_SACERDOTAL: "https://formularios.messianica.org.br/",
    PORTAL_URL: "https://portal.sistemaprover.com.br",
    LOGO_URL: "https://sis.sistemaprover.com.br/services/loadImg",
    URL_CONTRIBUA: "https://portal.sistemaprover.com.br/frontend/contribuicao/listar?t=",
    SIS_URL: 'http://prover.develop/',
    isMessianica: true,
  },
  producao: {
    ...baseConfig,
    API_URL: "https://portal.messianica.plataformaprover.com.br/api/asteria",
    API_ANTIGA_URL: "https://messianica.plataformaprover.com.br/api/v3",
    DOWNLOAD_URL: "https://messianica.plataformaprover.com.br/public/download",
    IMG_URL: "https://messianica.plataformaprover.com.br/public/img",
    BACKEND_IMG_URL: "https://messianica.plataformaprover.com.br/backend/anexo/img?f=",
    URL_EXAME_SACERDOTAL: "https://formularios.messianica.org.br/",
    PORTAL_URL: "https://portal.messianica.plataformaprover.com.br",
    LOGO_URL: "https://messianica.plataformaprover.com.br/services/loadImg",
    URL_CONTRIBUA: "https://portal.messianica.plataformaprover.com.br/frontend/contribuicao/listar?t=",
    SIS_URL: 'https://messianica.plataformaprover.com.br/',
    APP_VERSION: "1818",
    isMessianica: true,
  },
  staging: {
    ...baseConfig,
    API_URL: "https://portal.staging.messianica.plataformaprover.com.br/api/asteria",
    API_ANTIGA_URL: "https://staging.messianica.plataformaprover.com.br/api/v3",
    DOWNLOAD_URL: "https://staging.messianica.plataformaprover.com.br/public/download",
    IMG_URL: "https://staging.messianica.plataformaprover.com.br/public/img",
    BACKEND_IMG_URL: "https://staging.messianica.plataformaprover.com.br/backend/anexo/img?f=",
    URL_EXAME_SACERDOTAL: "https://formularios.staging.messianica.plataformaprover.com.br/",
    PORTAL_URL: "https://portal.staging.messianica.plataformaprover.com.br",
    LOGO_URL: "https://messianica.plataformaprover.com.br/services/loadImg",
    URL_CONTRIBUA: "https://portal.messianica.plataformaprover.com.br/frontend/contribuicao/listar?t=",
    SIS_URL: 'https://staging.messianica.plataformaprover.com.br',
    APP_VERSION: "1818",
    isMessianica: true,
  },
};

const isMessianica = false;
const env = "producao";
const envMessianica = "producao";

export const environment = isMessianica ? messianica[envMessianica] : prover[env];

export const firebase_options = {
  apiKey: "AIzaSyBiyrPillroxK1FXVS-aCQxMBThqdBHWWU",
  authDomain: "sistemaprover2015.firebaseapp.com",
  databaseURL: "https://sistemaprover2015.firebaseio.com",
  projectId: "sistemaprover2015",
  storageBucket: "sistemaprover2015.appspot.com",
  messagingSenderId: "536983349899",
  vapidKey: "BMqQ7fHnS2KiVYIyN1Q_55sRWma-7c4BXZNuBLDe2I3UwCv3-0-l8W3bj43oxkLQB8TW4Agolifx9rubDmvMyHQ",
};
